import React, { useState, useEffect, useRef } from 'react'

import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { createIncomeService } from '../../services/income.service';

import useUserData from '../../hooks/useUserData';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../reducers/user.reducer';

import TransferTypeSB from '../Transfer/components/TransferTypeSB'

import UserSelect from './components/UserSelect'
import useTransferTypeData from '../../hooks/useTransactionTypeData';
import { useNavigate } from 'react-router-dom';


const IncomeData = () => {
    const [user, setUser] = useState({ 'userId': '', 'name': 'User' });
    const [expand, setExpand] = useState(false);
    const [transferType, setTransferType] = useState({'transactionTypeId': '', 'transactionType' : 'Transfer Type'});
    const [transferTypeData, setTransferTypeData] = useTransferTypeData([]);
    const [incomeDate, setIncomeDate] = useState(new Date().toISOString().split('T')[0]);
    const [userData, setUserData] = useUserData([]);
    const [errors, setErrors] = useState({});
    const [expandTransferType, setExpandTransferType] = useState(false);
    const [description, setDescription] = useState('');

    const [amount , setAmount] = useState(0);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userLoginData = useSelector(selectUserData);

    useEffect(() => {
        setUser({
            userId: userLoginData?.userInfo?.userId,
            username: userLoginData?.userInfo?.username
        });
    }, [userLoginData]);

    const inputRef = useRef(null);

    const handleFocus = () => {
        inputRef.current.select();
    };

    // const resetForm = () => {
    //     setExpand(false);
    //     setUser({ 'userId': '', 'name': 'User' });
    //     setAmount(0);
    //     setDescription('');
    //     setErrors({});
    // }

    const selectUser=(e)=>{
        e.stopPropagation();
        setExpand(!expand);
    }

    const selectTransferType=(e)=>{
        e.stopPropagation();
        setExpandTransferType(!expandTransferType);
    }

    let handleSubmit = (event) => {
        event.preventDefault();
        const validateErrors = validate();
        if(Object.keys(validateErrors).length === 0) {
            createAction();
        }
        else {
            setErrors(validateErrors);
        }
    }

    const validate = () => {
        let errors = {};
        if(!user.userId) {
            errors.userId = 'User is required';
        }else if(!amount) {
            errors.amount = 'Amount is required';
        }else if(!description) {
            errors.description = 'Description is required';
        }else if(!transferType) {
            errors.transferType = 'TransferType is required';
        }

        return errors;
    }

    const createAction = async () => {
        dispatch(setIsLoading(true))

        try {
            let result;

            result = await createIncomeService({
                    toUserId: user.userId,
                    amount: parseInt(amount),
                    transactionTypeId: transferType.transactionTypeId,
                    description: description
                });
                if(result) {
                    dispatch(
                        setToastMessage({
                            message: "Success",
                            type: "success",
                        })
                    );
                    setTimeout(() => {
                        navigate('/income-details');
                    }, 2000)
                }

        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
            dispatch(setIsLoading(false))
        }
    }

    return (
        <div>
            <div className='bg-white rounded-sm h-[90dvh] mx-2 my-2'>

                <div className='w-64 h-[23%] flex justify-end items-end mx-auto'>
                    {/* <input
                        type="date"
                        name='incomeDate'
                        value={incomeDate}
                        onChange={(e) => setIncomeDate(e.target.value)}
                        className='bg-bgColor px-2 py-2 outline-none shadow-lg w-[185px] rounded-sm mb-16'
                     /> */}
                </div>

                <form
                    className='flex flex-col gap-5 justify-center items-center h-[60%] w-64 mx-auto'
                    onSubmit={handleSubmit}
                >

                        {/* <UserSelect
                            user={user}
                            setUser={setUser}
                            selectUser={selectUser}
                            userData={userData}
                            setExpand={setExpand}
                            expand={expand}
                        /> */}

                        {errors.userId && <p className='text-red text-xs font-bold'>{errors.userId}</p>}
                    <input
                        type="number"
                        name='amount'
                        value={amount}
                        ref={inputRef}
                        onFocus={handleFocus}
                        className='bg-bgColor rounded-sm py-2 px-3 w-full outline-none text-end shadow-lg '
                        placeholder='Amount'
                        onChange={(e) => setAmount(parseFloat(e.target.value))}
                    />

                        {errors.amount && <p className='text-red text-xs font-bold'>{errors.amount}</p>}

                    <TransferTypeSB
                        transferType={transferType}
                        setTransferType={setTransferType}
                        selectTransferType={selectTransferType}
                        transferTypeData={transferTypeData}
                        setExpandTransferType={setExpandTransferType}
                        expandTransferType={expandTransferType}
                        shadow={true}
                    />

                        { errors.transferType && <div className='text-red'>{errors.transferType}</div> }

                    <input
                        type="text"
                        name='description'
                        value={description}
                        className='bg-bgColor rounded-sm py-2 px-3  w-full outline-none shadow-lg '
                        placeholder='Description'
                        onChange={(e) => setDescription(e.target.value)}
                    />

                        {errors.description && <p className='text-red text-xs font-bold'>{errors.description}</p>}

                    <div className='flex flex-col gap-5 w-full items-end mt-16 text-white font-semibold'>
                        <button type='submit' className='bg-buttonBlue rounded-sm py-2 w-32 shadow-lg '>Save Income</button>
                        {/* <button type='button' className='bg-buttonRed rounded-sm py-2 w-32'>Cancel</button> */}
                    </div>
                </form>

            </div>
        </div>
    )
}

export default IncomeData
